module.exports = __webpack_public_path__ + "img/BTC.4b7cdf82.svg";